export class ActionConstant {
  static actionSaveOrderMoneyTmp: string = "saveOrderMoneyTmp";
  static actionSaveOrder: string = "saveOrder";
  static actionConfirmLogined: string = "action_confirm_logined";
  static actionConfirmAddCart: string = "action_confirm_addCart";
  static actionCheckRv: string = "checkRvSuccessfull";
  static actionConfirmDownload: string = "action_confirm_download";
  static actionConfirmRegister: string = "action_confirm_register";
  static ACTION_CONFIRM_REMOVE_ITEM_OF_CART = "action_confirm_remove_item_of_cart";
  static ACTION_CONFIRM_CANCEL_ORDER = "action_confirm_cancel_order";
  static ACTION_REMOVE_LIST_ITEM = "action_remove_list_item";
  static ACTION_REMOVE_ITEM = "action_remove_item";
  static ACTION_CART_DOES_NOT_EXIST = "action_cart_does_not_exist";
  static actionBackToHome = "action_back_to_home";
}